import { render, staticRenderFns } from "./reportRecordList.vue?vue&type=template&id=1be4cb11"
import script from "./reportRecordList.vue?vue&type=script&lang=js"
export * from "./reportRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports